import React, { useState, useEffect, useCallback, useRef } from "react";
import { QrReader } from "react-qr-reader";
import axios from "axios";
import BASE_URL from "../context/AppConfig";

const QRScanner = () => {
  const [scanResult, setScanResult] = useState("");
  const [message, setMessage] = useState("");
  const [mess, setMess] = useState("");
  const [gpsLocation, setGpsLocation] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const [scannerEnabled, setScannerEnabled] = useState(false);
  const [worksite, setWorksite] = useState([]);
  const [selected, setSelected] = useState("");
  const [workerId, setWorkerId] = useState(null); // Store parsed worker ID
  const scanLockRef = useRef(false);

  const getWorksite = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/worksite/`);
      setWorksite(response.data);
    } catch (error) {
      console.error("Error fetching worksite data", error);
      setMessage("Error fetching worksite data");
    }
  };

  const handleChange = (e) => {
    setSelected(e.target.value);
  };

  useEffect(() => {
    getWorksite();
  }, []);

  const getLocation = () => {
    setMessage("Fetching GPS location...");
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        setMessage("Geolocation not supported.");
        return reject("Geolocation not supported");
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setGpsLocation(location);
          setMessage("GPS location acquired.");
          resolve(location);
        },
        (error) => {
          setMessage("Failed to get GPS location.");
          reject(error);
        }
      );
    });
  };

  const startScan = async () => {
    try {
      await getLocation();
      setScanResult(null);
      setWorkerId(null);
      setIsScanning(false);
      scanLockRef.current = false;
      
      setScannerEnabled(true);
      setMessage("Ready to scan. Please show QR code.");
    } catch (err) {
      setScannerEnabled(false);
    }
  };

  const stopScanner = () => {

    setScannerEnabled(false);
    setIsScanning(false);
  };

  const handleScan = useCallback(
    async (result, error) => {
      if (scanLockRef.current || !scannerEnabled) return;
      if (result?.text && !isScanning) {
        scanLockRef.current = true;
        setIsScanning(true);
        const scannedText = result.text;
        setScanResult(scannedText);

        const idMatch = scannedText.match(/ID:\s*(\d+)/i);
        const parsedWorkerId = idMatch ? idMatch[1] : null;

        if (!parsedWorkerId) {
          setMessage("Invalid QR format: ID not found.");
          stopScanner();
          scanLockRef.current = false;
          return;
        }

        setWorkerId(parsedWorkerId); // Set for marking attendance
        setMessage("QR Code scanned. Click 'Mark Attendance'.");
        
        scanLockRef.current = false;
      }
    },
    [scannerEnabled, isScanning]
  );

  const markAttendance = async () => {
    if (!workerId || !selected || !gpsLocation) {
      setMessage("Missing worker ID, worksite or location.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${BASE_URL}/scan-qr/`,
        {
          worker_id: workerId,
          worksite_id: selected,
          latitude: gpsLocation.latitude,
          longitude: gpsLocation.longitude,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.needs_confirmation) {
        const confirm = window.confirm(`${response.data.message}\nDo you really want to check out?`);
        if (confirm) {
          // Call again with force_checkout = true
          const confirmResponse = await axios.post(`${BASE_URL}/scan_qr_code/`, {
            worker_id: workerId,
          worksite_id: selected,
          latitude: gpsLocation.latitude,
          longitude: gpsLocation.longitude,
            force_checkout: true,
          });
          alert(confirmResponse.data.message);
        }
      } 
      setMess(response.data.message || "Attendance marked successfully.");
      
    } catch (err) {
      setMess("Error: " + (err.response?.data?.error || "Scan failed"));
    }
    
    
  };

  

  useEffect(() => {
    if (!scannerEnabled) {
      stopScanner();
    }
  }, [scannerEnabled]);

  return (
    <div className="container mt-4">
      <h2>Worker QR Scanner</h2>

      <label htmlFor="worksite">Select Work site:</label>
      <select id="worksite" value={selected} onChange={handleChange} className="form-control mb-3">
        <option value="">-- Select --</option>
        {worksite.map((site) => (
          <option key={site.id} value={site.id}>
            {site.name}
          </option>
        ))}
      </select>

      <button  className="btn btn-primary mb-3" onClick={startScan}>
        Start Scan
      </button>
   

      {gpsLocation && (
        <div className="mb-3">
          <p>Latitude: {gpsLocation.latitude}</p>
          <p>Longitude: {gpsLocation.longitude}</p>
        </div>
      )}

      {scannerEnabled ? (
        <div style={{ width: "250px", height: "250px", margin: "auto" }}>
          <QrReader
            onResult={handleScan}
            scanDelay={500}
            constraints={{ facingMode: "environment" }}
            style={{ width: "100%" }}
          />
        </div>
      ) : (
        <p className="alert alert-info">Scanner is not active.</p>
      )}

      {scanResult && <p>Scanned Text: {scanResult}</p>}

      {workerId && (
        <button className="btn btn-success mt-2" onClick={markAttendance}>
          Mark Attendance
        </button>
      )}
      

      {message && <p className="alert alert-info mt-3">{message}</p>}
      {mess && <p className="alert alert-info mt-3">{mess}</p>}
    </div>
  );
};

export default QRScanner;
